module.exports = __webpack_public_path__ + "img/slim.426b5f09.png";